// extracted by mini-css-extract-plugin
export default {"wrapper":"TopHeader_wrapper__daEkA","button":"TopHeader_button__lIR2D","text":"TopHeader_text__Qolj3"};